export interface DisplayNameSource {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  id: number | string;
}

export const getDisplayName = (
  person: DisplayNameSource,
  { fallbackLabel = "User" }: { fallbackLabel?: string } = {},
) => {
  const name = [person.firstName, person.lastName].filter(Boolean).join(" ");
  return name || person.email || `${fallbackLabel} #${person.id}`;
};

export const getInitials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
